module.exports = __webpack_public_path__ + "static/media/company-logo2.d39be2c9.png";